
    import Component from 'vue-class-component';
    import {
        Certificate,
        CertificateRequirementViewModel,
        RequirementsClient
    } from "@/api-client";
    import {Prop} from "vue-property-decorator";
    import RequirementSummary from "@/features/applications/components/RequirementSummary";
    import CertificateDetailsContent from "@/features/certificates/CertificateDetailsContent.vue";

    @Component({
        components: {CertificateDetailsContent}
    })
    export default class CertificateRequirementSummary extends RequirementSummary {

        @Prop({required: true})
        requirement!: CertificateRequirementViewModel;

        chosenCertificate: Certificate[] | null = null;

        async created() {
            if (this.requirementValue) {
                this.chosenCertificate = await new RequirementsClient().chosenCertificate(this.application.id, this.requirement.id);
            }
        }
    }
